/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Coherent Labs AD. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import SpatialNavigation from './lib_components/spatial-navigation';
import IM from './utils/global-object';

IM.init();

export default SpatialNavigation;
